import { ActionElementProps } from '@collaborate-health/forms'
import { useDispatch, useSelector } from '@tabeeb/store'
import { Tooltip } from '@collaborate-health/uikit'

import { getContentId } from '@tabeeb/shared/content/selectors'
import { getIsFormActionDisabled, getSelectedTabs } from '@tabeeb/modules/forms/selectors'
import { triggerFormAction } from '@tabeeb/modules/forms/actions'
import { FormActionCreateOrUpdateRequest } from '@tabeeb/contracts/main-api/swagger-main-api'
import { FormActionButton } from './FormAction.styles'

const FormAction: React.FC<ActionElementProps<FormActionCreateOrUpdateRequest>> = ({ action }) => {
  const dispatch = useDispatch()

  const contentId = useSelector(getContentId)
  const isDisabled = useSelector((state) => getIsFormActionDisabled(state, { actionId: action.meta?.Id! }))
  const selectedFormTabsIds = useSelector(getSelectedTabs)

  return (
    <Tooltip placement='top' text={action.meta?.Tooltip || action.name}>
      <span>
        <FormActionButton
          onClick={() =>
            dispatch(
              triggerFormAction.request({
                FormActionId: action.meta?.Id!,
                ContentId: contentId,
                SelectedFormTabsIds: selectedFormTabsIds,
              })
            )
          }
          size='small'
          variant='contained'
          color='primary'
          fullWidth
          disabled={isDisabled || !contentId}
        >
          {action.name}
        </FormActionButton>
      </span>
    </Tooltip>
  )
}

export default FormAction

